import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import ReportDetail from '../components/ReportDetail';

type ReportDetailTabsState = {
  activeTabIndex: number;
  setActiveTabIndex: (value: number) => void;
};

export const useReportDetailTabsStore = create<ReportDetailTabsState>()(
  persist(
    (set) => ({
      activeTabIndex: 0,
      setActiveTabIndex: (value: number) => set({ activeTabIndex: value }),
    }),
    {
      name: 'report-detail-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

function ReportDetailPage() {
  const { placeCode } = useParams();
  const [searchParams] = useSearchParams();
  const { setActiveTabIndex } = useReportDetailTabsStore();

  useEffect(() => {
    if (searchParams.get('action') === 'approvement') {
      setActiveTabIndex(1);
    }
    return () => {
      setActiveTabIndex(0);
    };
  }, []);

  return placeCode ? <ReportDetail placeCode={placeCode} /> : null;
}

export default ReportDetailPage;
